<template>
    <div class="automation-trigger-settings">
        <p>
            {{ t('automations-form-triggers_config-joined_segment-description') }}
        </p>

        <div class="field">
            <div v-if="segments.length > 0">
                <label
                    :class="{
                        label: true,
                        'label-danger': !isFieldValid('segmentId'),
                    }"
                    >{{ t('automations-form-triggers_config-joined_segment-segment_label') }}
                </label>
                <select v-model="segmentId" class="form-control">
                    <option value="">{{ t('automations-form-triggers_config-joined_segment-segment_placeholder') }}</option>
                    <option
                        v-for="segment in segments"
                        :key="segment.id"
                        :value="segment.id"
                    >
                        {{ segment.name }}
                    </option>
                </select>
            </div>
            <div v-else>
                <span class="far fa-spinner fa-spin" /> {{ t('automations-form-triggers_config-joined_segment-loading_segments') }}
            </div>
        </div>
    </div>
</template>
<style lang="less">
.filter-value {
    .row.inputs {
        margin-top: 10px;
    }
    input {
        margin-top: 4px;
    }
}
</style>
<script>
import keviApi from "../../../keviApi";

export default {
    props: {
        value: {
            type: Array,
            default: [],
        },
    },
    data: function () {
        let segmentId =
            this.value.length > 0 && this.value[0].segmentId
                ? this.value[0].segmentId
                : "";
        return {
            segmentId: segmentId,
            segments: [],
        };
    },
    computed: {
        errors() {
            let errors = {};

            if (!this.segmentId) {
                // i18n-validator-ignore-next-line: validation key
                errors["segmentId"] = "select-segment";
            }
            return errors;
        },
    },
    mounted: function () {
        let options = keviApi.getOptions("segments");
        this.$http(options).then((response) => {
            this.segments = response.body;
            window.setTimeout(() => {
                this.changed();
            }, 100);
        });
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        isFieldValid(field) {
            return !Object.keys(this.errors).includes(field);
        },
        isValid: function () {
            return Object.keys(this.errors).length === 0;
        },
        changed: function () {
            this.$emit("input", [
                {
                    segmentId: this.segmentId,
                },
            ]);
        },
    },
    watch: {
        segmentId: function () {
            this.changed();
        },
        filter: function () {
            this.changed();
        },

        value: function () {
            let segmentId =
                this.value.length > 0 && this.value[0].segmentId
                    ? this.value[0].segmentId
                    : "";

            if (segmentId !== this.segmentId) {
                this.segmentId = segmentId;
            }
        },
    },
};
</script>
